import moment from "moment";
/**
 * Calculates and formats milestone dates for different milestones.
 *
 * @param babyBirthDateFormat - The formatted birth date string for the baby.
 * @param babySelected - The selected baby object containing birth_date, baby_birthdate, or baby_duedate.
 * @param currentMilestone - The milestone object containing age_weeks and pregnancy_weeks.
 * @returns An object with milestoneTitle and initialTitle, both formatted as "Month Day, Year".
 */
const STANDARD_WEEKS_FOR_PREGNANCY_MILESTONE = 40;
const handleMilestoneDate = (
  babyBirthDateFormat: string,
  babySelected: any,
  currentMilestone: any,
) => {
  let initialTitle = "";
  let milestoneTitle = "";
  switch (currentMilestone.age_weeks) {
    case -1: // custom page
      milestoneTitle = moment().format("MMMM Do, YYYY");
      initialTitle = milestoneTitle;
      break;
    case -2: //photos-only
      milestoneTitle = moment().format("MMMM Do, YYYY");
      initialTitle = "";
      break;
    case -700: //pregnancy miletones
      if (currentMilestone.pregnancy_weeks === null) {
        // If pregnancy_weeks is null, set milestoneTitle to today's date (formatted)
        // data for non-aged based pegnancies
        milestoneTitle = moment().format("MMMM Do, YYYY");
        initialTitle = milestoneTitle;
      } else {
        //data for age/week-based pregnancies - calculated
        initialTitle = moment(babySelected.baby_birthdate)
          .subtract(
            STANDARD_WEEKS_FOR_PREGNANCY_MILESTONE -
              currentMilestone.pregnancy_weeks,
            "week",
          )
          .format("MMMM Do, YYYY");
        milestoneTitle = initialTitle;
      }
      break;
    case -800: //first events
      milestoneTitle = moment().format("MMMM Do, YYYY");
      initialTitle = milestoneTitle;
      break;
    default:
      //values assigned to all other milestones
      initialTitle = babySelected.baby_birthdate
        ? babyBirthDateFormat
        : moment(babySelected.baby_duedate).format("MMMM Do, YYYY");
      milestoneTitle = initialTitle;
      break;
  }
  return {
    milestoneTitle: milestoneTitle,
    initialTitle: initialTitle,
  };
};

export default handleMilestoneDate;
